package learning.containers

import com.jingfangpai.api.clients.CommentApiClient
import com.jingfangpai.api.clients.ContentApiClient
import com.jingfangpai.api.clients.SignSymptomApiClient
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.content.model.ContentVo
import com.jingfangpai.contentEntity.model.ContentConnectionDto
import react.*
import react.dom.div
import setTitle
import learning.components.ShangHanLunReading

external interface ShangHanLunReadingPageProps : RProps {

}

data class ShangHanLunReadingPageContextData(
    val query:(query:com.jingfangpai.content.model.ContentQuery, okCallback: (result:ApiResponse<Array<ContentVo>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    val getContainers:(entityType:com.jingfangpai.common.orm.mapping.enums.ContentEntityType,entityId:kotlin.String,parentId:kotlin.String?, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.data.model.CascadedOption<kotlin.String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getOptions:(okCallback: (result: ApiResponse<Array<CascadedOption<String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit,
    var fetchBookComments:(type:com.jingfangpai.common.orm.mapping.enums.CommentType,bookId:kotlin.String,authorId:kotlin.String, okCallback: (result:ApiResponse<Array<com.jingfangpai.common.orm.mapping.Comment>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var saveContentConnection:(contentConnection: ContentConnectionDto, okCallback: (result:ApiResponse<ContentConnectionDto>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var saveComment:(comment:com.jingfangpai.common.orm.mapping.Comment, okCallback: (result:ApiResponse<com.jingfangpai.common.orm.mapping.Comment>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getComments:(entityType:com.jingfangpai.common.orm.mapping.enums.CommentEntityType, entityId:kotlin.String, type:com.jingfangpai.common.orm.mapping.enums.CommentType, okCallback: (result:ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.Comment>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val ShangHanLunReadingPageContext = createContext(ShangHanLunReadingPageContextData(ContentApiClient::query,ContentApiClient::getContainers,SignSymptomApiClient::getOptions,CommentApiClient::fetchBookComments,ContentApiClient::saveConnection,CommentApiClient::save,CommentApiClient::getComments))

val ShangHanLunReadingPageProvider = functionalComponent<ShangHanLunReadingPageProps> { props ->

    setTitle("精读伤寒论")

    useEffectOnce { }

    ShangHanLunReadingPageContext.Provider(ShangHanLunReadingPageContextData(ContentApiClient::query,ContentApiClient::getContainers,SignSymptomApiClient::getOptions,CommentApiClient::fetchBookComments,ContentApiClient::saveConnection,CommentApiClient::save,CommentApiClient::getComments)) {
        div("ShangHanLunReadingPage-page") {
            child(ShangHanLunReading) {

            }
        }
    }
}
